import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { filter, map, Observable, startWith, Subscription, switchMap, tap } from 'rxjs';
import { GridFiltersComponent, streetWithHouseNumberValidator } from '../grid-filters/grid-filters.component';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { BaseComponent } from '../../base/base-component.directive';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';


export const MY_DATE_FORMATS = {

  parse: {

    dateInput: 'DD/MM/YYYY',

  },

  display: {

    dateInput: 'DD/MM/YYYY',

    monthYearLabel: 'MMMM YYYY',

    dateA11yLabel: 'LL',

    monthYearA11yLabel: 'MMMM YYYY'

  },

};
@Component({
  selector: 'app-report-filter-dialog',
  templateUrl: './report-filter-dialog.component.html',
  styleUrls: ['./report-filter-dialog.component.scss'],
  providers:[
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }]
})
export class ReportFilterDialogComponent extends BaseComponent implements OnInit {
  filterFormGroup: FormGroup = this.formBuilder.group({
    field: [null, [Validators.required]],
    value: [null, [Validators.required]],
    type:[null]
  });

  range: FormGroup= this.formBuilder.group({
    field: [null, [Validators.required]],
    start: [null, [Validators.required]],
    end: [null, [Validators.required]],
  });

  addressFormGroup: FormGroup = this.formBuilder.group({
    field: [null, [Validators.required]],
    city: [null, [Validators.required]],
    street: [null],
    house_number: [null],
  },
  { validators: streetWithHouseNumberValidator() });

  filteredOptions: Observable<FilterFieldOption[]>;
  filters:{ name: string; field: string; value: any }[] = [];

  layoutDirection: 'row' | 'column' = 'column';
  options: FilterFieldOption[];
  value: any;
  values:any[]=[]
  values_id:any[]=[]
  start: string;
  end: string;
  separatorKeysCodes: number[] = [ENTER, COMMA]
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  selectedValue= 0;
  type?:string[]

  rawData: Array<any> = [];
  selectData: Array<any> = []

  @ViewChild('valueInput') valueInput: ElementRef;
  get selectedField(): FilterField {
    return this.filterFormGroup.value?.field;
  }

  get FieldType(): typeof FieldType {
    return FieldType;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: GridFilterParam,
    private dialogRef: MatDialogRef<GridFiltersComponent>,
    private formBuilder: FormBuilder
  ) {
    super();
  }

  get_subcategory(value:number){
    if(this.options[0].json && this.filterFormGroup.value && typeof(value)==='number'){
      return this.options?.filter((option) =>
        option?.id === value
      )[0].json;
    }
    return []
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      this.values.push(value.trim());
    }
    if (input) {
      input.value = '';
    }
  }

  remove(option: FilterFieldOption): void {
    const index = this.values.indexOf(option);
    if (index >= 0) {
      this.values.splice(index, 1);
    }
  }
  
  selected(event: MatAutocompleteSelectedEvent): void {
    this.values.push(event.option.viewValue);
    this.valueInput.nativeElement.value = '';
  }

  selected_id(event: MatAutocompleteSelectedEvent): void {
    this.values_id.push(event.option.value);
    this.values.push(event.option.viewValue);
    this.valueInput.nativeElement.value = '';
  }


  setLayout(){
    if(window.innerWidth > 2000){
      this.layoutDirection = 'row'; 
    } else {
      this.layoutDirection = 'column';
    }
  }

  removeFilter(index: number): void {
    this.filters.splice(index, 1);
  }
  
  
  ngOnInit(): void {
    this.setLayout();
    this.filteredOptions = this.filterFormGroup.get('value').valueChanges.pipe(
      startWith(''),
      map((val: string | FilterFieldOption) => this._filterOptions(val))
    );

    this.addressFormGroup
      .get('field')
      .valueChanges.pipe(filter((val) => val.options))
      .pipe(switchMap((val) => val.options as Observable<FilterFieldOption[]>))
      .pipe(this.autoDispose())
      .subscribe((res) => (this.options = res));
    
    this.range
      .get('field')
      .valueChanges.pipe(filter((val) => val.options))
      .pipe(switchMap((val) => val.options as Observable<FilterFieldOption[]>))
      .pipe(this.autoDispose())
      .subscribe((res) => (this.options = res));

    this.filterFormGroup
      .get('field')
      .valueChanges.pipe(filter((val) => val.options))
      .pipe(switchMap((val) => val.options as Observable<FilterFieldOption[]>))
      .pipe(this.autoDispose())
      .subscribe((res) => (this.options = res));

  }

  formatChipValue(value: any): string {
    if (Array.isArray(value)) {
      return value.join(', ');
    }
    if (typeof value === 'object' && value !== null) {
      try {
        return JSON.stringify(value);
      } catch {
        return '';
      }
    }
    return String(value);
  }

  setAddress(){
    if(this.addressFormGroup.value.street !== null && this.addressFormGroup.value.house_number !== null){
      const val = this.addressFormGroup.value.city + "," + this.addressFormGroup.value.street + "," + this.addressFormGroup.value.house_number
      return val
    }
    if(this.addressFormGroup.value.street !== null && this.addressFormGroup.value.house_number === null ){
      const val = this.addressFormGroup.value.city + "," + this.addressFormGroup.value.street 
      return val
    }
    if(this.addressFormGroup.value.street === null && this.addressFormGroup.value.house_number !== null){
      const val = this.addressFormGroup.value.city + "," + this.addressFormGroup.value.house_number
      return val
    }
    else{
      const val = this.addressFormGroup.value.city;
      return val
    }
  }

  addFilter() {
    var chips: string[] = [];
    this.addressFormGroup.markAllAsTouched();
    this.range.markAllAsTouched();
    this.filterFormGroup.markAllAsTouched();
  
    if (this.values.length !== 0) {
      this.filterFormGroup.value.value = this.values;
    }
    if (this.values_id.length !== 0) {
      this.filterFormGroup.value.value = this.values_id;
      chips = this.values;
    }
  
    const field = this.filterFormGroup.value.field;
  
    // --- Standard filter field
    if (this.filterFormGroup.value.value !== null && this.filterFormGroup.valid) {
      const { value, type } = this.filterFormGroup.value;
      const filter: any = { field: field.name, value };
  
      if (chips.length !== 0) filter.chips = chips;
      if (type != null) filter.type = type;
      this.filters.push({ name: field.text, field: field.name, value });
      //this.filters.push(filter);
      this.resetFormGroups(); // Custom method to clear form if needed
    }
  
    // --- Range type 5 (date)
    if (this.range.value.start && this.range.value.end && field.type === 5) {
      const start = moment(this.range.value.start._d).format('yyyy-MM-DD');
      const end = moment(this.range.value.end._d).format('yyyy-MM-DD');
      const value = `${start},${end}`;
      this.filters.push({ name: field.text, field: field.name, value });
      this.resetFormGroups();
    }
  
    // --- Range type 9 (timestamp)
    if (this.range.value.start && this.range.value.end && field.type === 9) {
      const start = this.range.value.start._d.valueOf();
      const end = this.range.value.end._d.valueOf();
      const value = `${start},${end}`;
      this.filters.push({ name: field.text, field: field.name, value });
      this.resetFormGroups();
    }
  
    // --- Address field
    if (!this.addressFormGroup.hasError('streetWithHouseNumberError') && this.addressFormGroup.value.city !== null) {
      const val = this.setAddress();
      this.filters.push({ name: field.text, field: field.name, value: val });
      this.resetFormGroups();
    }
  }

  resetFormGroups() {
    this.filterFormGroup.reset();
    this.range.reset();
    this.addressFormGroup.reset();
    this.values = [];
    this.values_id = [];

    this.setupFieldValueChanges(this.addressFormGroup);
    this.setupFieldValueChanges(this.range);
    this.setupFieldValueChanges(this.filterFormGroup);
  }


private setupFieldValueChanges(group: FormGroup) {
  group.get('field')?.valueChanges
    .pipe(
      filter((val) => val && val.options),
      switchMap((val) => val.options as Observable<FilterFieldOption[]>),
      this.autoDispose()
    )
    .subscribe((res) => {
      this.options = res;
    });
}




  applyFilters() {
    this.dialogRef.close(this.filters);
  }


  private _filterOptions(
    value: string | FilterFieldOption
  ): FilterFieldOption[] {
    if (typeof value === 'string') {
      const search = value.toUpperCase();
      return this.options?.filter((option) =>
        option?.description.toUpperCase().includes(search)
      );
    }
    return [];
  }

  check_if_json(){
    var res:boolean;
    if(this.options !== undefined){
      this.options.some(array=>{
        res=array.hasOwnProperty("json")
      })
    } else {
      res = false;
    }
    return res
  }

  displayFn() {
    return (groupId: string | number) =>
      this.options?.find((item) => item.description === groupId)?.description || this.options?.find((item) => item.id === groupId)?.description; 
  }
}

export type GridFilterParam = {
  fields: FilterField[];
};

export type FilterField = {
  name: string;
  text: string;
  type: FieldType;
  options?: Observable<FilterFieldOption[]>;
};

export enum FieldType {
  TEXT,//this.filterFormGroup.value.field.type===0
  AUTOCOMPLETE,//this.filterFormGroup.value.field.type===1
  DATETIME,//this.filterFormGroup.value.field.type===2
  UPPERCASE,//this.filterFormGroup.value.field.type===3
  UPPERCASE_ARRAY,//this.filterFormGroup.value.field.type===4
  DATERANGE,//this.filterFormGroup.value.field.type===5
  STATUS,//this.filterFormGroup.value.field.type===6
  LOwERCASE_ARRAY,//this.filterFormGroup.value.field.type===7
  BOOLEAN,//this.filterFormGroup.value.field.type===8
  GRAFANA_DATERANGE,//this.filterFormGroup.value.field.type===9
  GRAFANA_AUTOCOMPLETE,
  CONTRACT_TYPE,
  VEHICLE_STATUS,
  DOCTYPE,
  CLIENT_SIDE_BOOLEAN,
  AUTOCOMPLETE_DATE,
  AUTOCOMPLETE_UPPER,
  WASTE_TYPE,
  LOCATION,
  WHITELIST_TYPE,
  WLTAG_LIST_MODE,
  ADDRESS,
  SMARTBIN_STATE,
  WAYPOINT_STATUS,
  AUTOCOMPLETE_ARRAY,
  READING_STATUS,
  NUMBER
}

export type FilterFieldOption = { id: number; description: string, json?:NestedJson[]  };
export type NestedJson ={ cod:string; tipologia: string;}
export type Address = { city: string; street: string; house_number: string; }